<div class="page">
  <div class="page__container">
    <h1 class="page__title  h2" translate>smsadv_title</h1>
    <h3 class="my-5" translate>smsadv_subtitle</h3>
    <div class="my-5" [formGroup]="searchForm">
      <h3 class="my-5" translate>smsadv_create_gender</h3>
      <div>
        <div class="form-group d-flex w-100 margin-adjustement">
          <div class="form-check-inline">
            <label class="radio-custom">
              <input type="radio" formControlName="sexe" value="mixte" />
              <span class="radio-custom__radio"></span>
              <span class="radio-custom__label" translate>Mixte</span>
            </label>
            <label class="radio-custom">
              <input type="radio" formControlName="sexe" value="homme" />
              <span class="radio-custom__radio"></span>
              <span class="radio-custom__label" translate>Homme</span>
            </label>
            <label class="radio-custom">
              <input type="radio" formControlName="sexe" value="femme" />
              <span class="radio-custom__radio"></span>
              <span class="radio-custom__label" translate>Femme</span>
            </label>
          </div>
        </div>
      </div>
      <h3 class="my-5" translate>smsadv_create_age</h3>
      <div class="row">
        <div class="custom-slider mx-3 w-100">
          <ngx-slider [(highValue)]="maxValueSliderDemograph" [options]="optionsSliderDemoGraph" formControlName="age"></ngx-slider>
        </div>
      </div>
      <h3 class="my-5" translate>smsadv_create_area</h3>
      <div class="d-flex form-group">
        <ng-select
          [items]="zips$ | async"
          bindLabel="text"
          [trackByFn]="trackByFn"
          [minTermLength]="minLengthTerm"
          [loading]="zipsLoading"
          multiple="true"
          typeToSearchText="Please enter {{ minLengthTerm }} or more characters"
          [typeahead]="zipsInput$"
          [(ngModel)]="selectedZip"
          formControlName="zips"
          multiple="true"
          class="form-control col-sm-5"
        >
        </ng-select>
      </div>
      <h3 class="my-5" translate>smsadv_create_count_interest</h3>
      <div class="d-flex form-group">
        <ng-select
          [items]="ciCriteriaItems"
          bindLabel="text"
          bindValue="value"
          multiple="true"
          formControlName="ci"
          class="form-control col-sm-5"
        >
        </ng-select>
      </div>
      <div *ngIf="dataVolume.length">
        <h3 class="my-5" translate>smsadv_create_count_recipients</h3>
        <table class="table" formArrayName="estimate">
          <thead style="font-size: 13px;">
            <tr>
              <th translate>Localité</th>
              <th translate>Volume possible</th>
              <th class="text-end" translate>Volume souhaité</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let volume of estimateControlsArray; let i = index" [formGroupName]="i">
              <td>{{ volume.get('zip').value }}</td>
              <td>{{ volume.get('quantityAvailable').value }}</td>
              <td class="text-end">
                <input
                  type="number"
                  id="quantityDesired"
                  formControlName="quantityDesired"
                  class="form-control w-50 float-right text-end"
                  [max]="volume.get('quantityAvailable').value"
                  name="quantityDesired"
                />
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>Total</td>
              <td>{{ totalVolumeCountAvalaible }}</td>
              <td class="text-end">{{ totalVolumeCountDesired }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="col-12 d-flex justify-content-end">
        <wsb-atlas-button
          class="my-3 me-3"
          [label]="'smsadv_create_ask_estimate'"
          *ngIf="dataVolume.length"
          (click)="openAskEstimate(askEstimate)"
        ></wsb-atlas-button>
        <wsb-atlas-button class="my-3" [label]="'common_search'" [disabled]="searchForm.invalid" (click)="search()"></wsb-atlas-button>
      </div>
    </div>
  </div>
</div>

<ng-template #askEstimate let-c="close" let-d="dismiss">
  <wsb-modal (dismiss)="d()" title="{{ 'smsadv_create_ask_estimate' | translate }}" (primary)="askestimate()">
    <div body class="text-center">
      <span translate>smsadv_are_u_sure_estimate</span>
    </div>
  </wsb-modal>
</ng-template>
